var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/back_icon_white.53047804.png","uri@2x": __webpack_public_path__ + "static/media/back_icon_white.5c549bf8.png",
    width: 16,
    height: 16
});